module.exports = __webpack_public_path__ + "static/media/bell-plus.fca89c10.svg";